import styled from "styled-components";
import { Input } from "@progress/kendo-react-inputs";

interface Props {
  texttransform?:
    | "capitalize"
    | "uppercase"
    | "lowercase"
    | "none"
    | "full-width"
    | "inherit"
    | undefined;
}

const TextInput = styled(Input)<Props>`
  ${(props) => (props.readOnly ? "background-color: #f8f8f8;" : "")}
  text-transform: ${(props) => props.texttransform ?? "none"};

  &:disabled {
    background-color: #f8f8f8;
  }
`;

export default TextInput;
